import { X } from "@phosphor-icons/react";
import { API_BASE } from "../../lib/api";
import { fmtSize } from "./utils";

export default function AttachmentLightbox({ att, onClose }) {
  if (!att) return null;
  const url = `${API_BASE}${att.download_url}`;
  const isPdf = (att.content_type || "").includes("pdf");
  return (
    <div
      className="fixed inset-0 bg-black/85 z-50 flex items-center justify-center p-6 animate-fade-up"
      onClick={onClose}
      data-testid="attachment-lightbox"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-[#FF3E00]"
        data-testid="attachment-lightbox-close"
      >
        <X size={20} />
      </button>
      <div className="max-w-5xl max-h-[90vh] flex flex-col items-center gap-3" onClick={(e) => e.stopPropagation()}>
        {att.is_image ? (
          <img src={url} alt={att.original_filename} className="max-w-full max-h-[80vh] object-contain" />
        ) : att.is_video ? (
          <video src={url} controls className="max-w-full max-h-[80vh]" data-testid="attachment-video-player" />
        ) : isPdf ? (
          <iframe src={url} title={att.original_filename} className="w-[80vw] h-[80vh] bg-white" />
        ) : (
          <a href={url} download={att.original_filename} className="bg-[#FF3E00] text-white font-semibold text-sm px-6 py-3 hover:bg-zinc-50 hover:text-zinc-950 transition-colors">
            DOWNLOAD {att.original_filename}
          </a>
        )}
        <div className="font-mono text-xs text-white/70 text-center">
          {att.original_filename} · {fmtSize(att.size)} · uploaded by {att.uploaded_by_email}
        </div>
      </div>
    </div>
  );
}
